<template>
    <div class="project-recipe-card-component mb-5">
        <div :class="['card', 'card-' + index]">
            <div class="card-body">
                <h2 class="card-title" v-html="recipe.name"></h2>
                <p class="card-text" v-html="recipe.description"></p>
                <div class="container-fluid px-0 btn-container">
                    <div class="row mt-5 pt-1">
                        <div class="col-5 left-btn-col" style="text-align: left">
                            <div class="card-link">
                                <button type="button" class="btn btn-outline-primary"
                                        data-toggle="modal" :data-target="'#recipe-' + index + '-modal'">
                                    How it works
                                </button>
                            </div>
                        </div>
                        <div class="col-7 right-btn-col" style="text-align: right">
                            <div class="card-link">
                                <button v-if="recipe.access" :disabled="recipe.disabled === 1" v-bind:class="{ selected: isSelected }" @click="selectCard"
                                        type="button" class="btn btn-primary">
                                    {{ getButtonTitle(recipe) }}
                                </button>
                                <a v-if="!recipe.access"
                                   v-bind:href="urls.recipePublicUrl + '/' + recipe.slug"
                                   class="btn btn-outline-primary">Investigate Now for 90€</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        props: ['recipe', 'isSelected', 'index'],
        computed: {
            ...mapGetters([
                'urls'
            ])
        },
        methods: {
            selectCard() {
                this.$emit('selected', this.recipe);
            },
            getButtonTitle(recipe) {
                if(this.isSelected)
                    return 'Recipe selected';
                if(recipe.disabled)
                    return 'Coming soon';
                return  'Select this recipe';
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../sass/variables";

    .selected {
        background-color: $blue-dark;
        color: #ffffff;
        border-color: #ffffff;
    }

    .btn.disabled, .btn:disabled {
        opacity: 0.4;
    }

    .project-recipe-card-component {
        margin: 0 1rem;
    }

</style>
